// extracted by mini-css-extract-plugin
export default {"control":"control_control__sksIw","action":"control_action__hpxCJ"};